//@ts-nocheck

const blogPagination = () => {
	const postsSection = document.querySelector(".js-posts-section");
	if (!postsSection) return;
	const position = postsSection.getBoundingClientRect();

	let container = postsSection.querySelector(".js-posts-container");
	if (!container) return;

	let currentPage = 1;
	let maxPage = parseInt(container.dataset.numberOfPages);

	postsSection.addEventListener("click", async function (event) {
		try {
			if (event.target.classList.contains("page-numbers")) {
				let page = parseInt(event.target.textContent);
				if (event.target.classList.contains("page-numbers-prev")) {
					page = currentPage - 1;
				} else if (
					event.target.classList.contains("page-numbers-next")
				) {
					page = currentPage + 1;
				}

				if (page < 1) {
					currentPage = 1;
				} else if (page > maxPage) {
					currentPage = maxPage;
				} else if (page == currentPage) {
					return;
				} else {
					currentPage = page;
				}

				let formData = new FormData();
				formData.append("action", "llc_load_posts");
				formData.append("page", page);

				postsSection.classList.add("loading");

				const response = await fetch(ajaxurl, {
					method: "POST",
					body: formData,
				});

				const res = await response.json();
				container.innerHTML = res.data;
				postsSection.classList.remove("loading");
				window.scrollTo(0, position.top);

				let paginationButtons = postsSection.querySelectorAll(".page-numbers");
				if (paginationButtons.length === 0) return;
				paginationButtons.forEach((button) => {
					button.classList.remove("active-page");
					if (button.textContent == currentPage)
						button.classList.add("active-page");
					if (currentPage === 1 && button.classList.contains("page-numbers-prev")) {
						button.disabled = true;
					} else if (currentPage === maxPage && button.classList.contains("page-numbers-next")) {
						button.disabled = true;
					}
				});
			}
		} catch {
			console.log("An error occured");
			postsSection.classList.remove("loading");
		}
	});
};

export default blogPagination;
